import { useForm, ValidationError } from '@formspree/react';

export default function ContactForm() {
    const [state, handleSubmit] = useForm("mbdpplvp");

    if (state.succeeded) {
        return <p className="bug-form-success">Thank you! I'll look into it.</p>;
    }

    return (
        <form className="bug-form" onSubmit={handleSubmit}>
            <div>
                <label htmlFor="email">Email Address <span className="bug-form-required">*</span></label>
                <input id="email" type="email" name="email" required />
                <ValidationError prefix="Email" field="email" errors={state.errors} className="bug-form-error" />
            </div>
            <div>
                <label htmlFor="message">Message <span className="bug-form-required">*</span></label>
                <textarea id="message" name="message" required />
                <ValidationError prefix="Message" field="message" errors={state.errors} className="bug-form-error" />
            </div>
            <button className="bug-form-submit" type="submit" disabled={state.submitting}>
                Submit
            </button>
        </form>
    );
}
